import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: {
    heading: "Trailer",
    play: (title: string) => `Ver el trailer de ${title}`,
    note: "Se reproduce desde YouTube.",
  },
  en: {
    heading: "Trailer",
    play: (title: string) => `Watch the ${title} trailer`,
    note: "Plays from YouTube.",
  },
});
